export const DEFAULT_THANK_YOU_TITLE = 'Thank You!';
export const DEFAULT_THANK_YOU_MESSAGE = 'Your submission has been received.';

export const getThankYouSettings = (formSettings = {}) => {
  const legacyMessage = formSettings.thank_you_text || '';
  const hasNewMessage = Boolean(formSettings.thank_you_description);
  return {
    title: formSettings.thank_you_title ||
      (!hasNewMessage && legacyMessage) ||
      DEFAULT_THANK_YOU_TITLE,
    message: formSettings.thank_you_description ||
      (legacyMessage ? '' : DEFAULT_THANK_YOU_MESSAGE),
    image: formSettings.thank_you_image || '',
    redirectUrl: formSettings.redirect_url || ''
  };
};

export const normalizeThankYouRedirectUrl = (value) => {
  const url = String(value || '').trim();
  if (!url) return '';

  let parsedUrl;
  try {
    parsedUrl = new URL(url);
  } catch (error) {
    throw new Error('Enter a valid HTTP or HTTPS URL.');
  }

  if (!['http:', 'https:'].includes(parsedUrl.protocol) || !parsedUrl.hostname) {
    throw new Error('Redirect URL must use HTTP or HTTPS.');
  }

  return parsedUrl.href;
};

export const buildThankYouSettings = ({ title, message, redirectUrl }) => ({
  thank_you_title: title,
  thank_you_description: message,
  redirect_url: normalizeThankYouRedirectUrl(redirectUrl)
});

export const getSafeThankYouRedirectUrl = (value) => {
  try {
    return normalizeThankYouRedirectUrl(value);
  } catch (error) {
    return '';
  }
};
